import React from "react";
import ErrorBoundary from "../../shared/ErrorBoundary/ErrorBoundary";
import Search from "./Search";

/**This component will serve as the component to be rendered in the App.js routing. 
 * The main purpose of this is to give the Search component the isAllProducts prop set to true when we are routing to /search
 *
 * @param {*} 
 * @returns Search component
 *
 */
const AllProductsResultsContainer = () => {
    return (
        <ErrorBoundary>
            <Search isAllProducts={true} />
        </ErrorBoundary>
    );
};

export default AllProductsResultsContainer;
